import cx from 'classnames';
import * as _ from 'lodash';
import { useEffect, useRef, useState, type VoidFunctionComponent } from 'react';

import { useIsOverflow } from '../../../hooks/useIsOverflow';
import Button, { BUTTON_TYPE } from '../Button';

import styles from './DynamicShowMoreText.module.less';

type Props = {
  text: string;
};

export const DynamicShowMoreText: VoidFunctionComponent<Props> = ({ text }) => {
  const ref = useRef<HTMLDivElement>(null);
  const isOverflow = useIsOverflow(ref);

  const [isShowingDescription, setIsShowingDescription] = useState(false);

  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(!isOverflow);
  }, [isOverflow]);

  return (
    <>
      <div ref={ref} className={cx(styles.textBlock, { [styles.expanded]: isShowingDescription || isExpanded })}>
        {!_.isEmpty(text) ? text : 'No description available.'}
      </div>
      {isOverflow ? (
        <Button
          type={BUTTON_TYPE.ANCHOR}
          onClick={() => setIsShowingDescription(!isShowingDescription)}
      >
          <div className={styles.buttonText}>{isShowingDescription ? 'Show less' : 'Show all'}</div>
        </Button>
      ) : null}
    </>
  );
};
